// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2rBZd","title":"Header_title__OKwzc","left":"Header_left__lAspT","clinicName":"Header_clinicName__2DE3G"};